<template>
  <form @submit.prevent="submitForm()" novalidate>
    <div class="my-1">
      <div class="input-group">
        <div class="input-group-text"><font-awesome-icon icon="fa-solid fa-phone" /></div>
        <input
          v-maska="objLogin.phone"
          :data-maska="objLogin.mask.phone"
          type="tel"
          name="phone"
          ref="loginphone"
          v-model="form.phone"
          @maska="onMaskaLoginPhone"
          class="form-control maska-phone"
          :class="{
            'form-control-sm': position == 'aside',
            'is-invalid': errors.form.phone.length || (objLogin.phone.unmasked.length && !objLogin.phone.completed),
            'is-valid': errors.form.phone.length == 0 && objLogin.phone.completed,
          }"
          :placeholder="objLogin.mask.phone.replaceAll('#', 'x')" />
        <div class="invalid-feedback">{{ errors.form.phone }}</div>
      </div>
    </div>

    <div data-error class="alert alert-warning mb-1 mt-3 px-2 py-1" role="alert">{{ errors.form.common }}</div>

    <div class="mt-2 mb-1 text-end">
      <button
        type="submit"
        class="btn btn-primary"
        :class="{ 'btn-sm': position == 'aside' }"
        :disabled="!objLogin.phone.completed || isLoading"
        title="Получить код для входа">
        <font-awesome-icon icon="fa-solid fa-key" /> Получить код
      </button>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPhone, faKey } from '@fortawesome/free-solid-svg-icons';
library.add(faPhone, faKey);

import { vMaska } from 'maska';
// import { countries, defaultFormat } from '@/constants/countries'

export default {
  directives: { maska: vMaska },
  data: function () {
    return {
      isLoading: false,
      //
      form: {
        _token: this.csrf,
        phone: '',
      },
      errors: {
        form: {
          phone: '',
          common: '',
        },
      },
      // maska:
      objLogin: {
        phone: {
          completed: false,
          masked: '',
          unmasked: '',
        },
        raw: {
          phone: '',
        },
        country: {
          phone: '7',
        },
        mask: {
          phone: '+7 (###) ###-##-##',
        },
      },
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
    // предзаполнить
    phone: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    // тут не используется
    until: {
      type: String,
      default: '',
    },
  },
  components: {
    FontAwesomeIcon,
  },
  methods: {
    submitForm() {
      // убрать старые ошибки
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      if (this.form.phone === '') {
        this.errors.form.phone = 'Нужно ввести номер телефона.';
        return false;
      }

      this.isLoading = true;

      axios
        .post(`/backend/login/request/sms`, this.form)
        .then((res) => {
          // ??? надо?
          if (res.data.message !== '') {
            this.$bs5utils.Snack.show('info', res.data.message, this.$store.getters.delay.info);
          }

          if (res.data.status === 'ok') {
            this.$emit('go-step', {
              step: 1,
              uid: res.data.uid,
              until: res.data.until,
              phone: this.form.phone,
            });
          }

          if (res.data.status === 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    //
    onMaskaLoginPhone(event) {
      this.objLogin.raw.phone = event.detail.unmasked;
    },
  },
  watch: {
    'form.phone'(newVal, oldVal) {
      if (newVal.length != oldVal.length) {
        this.errors.form.phone = '';
      }
    },
  },
  mounted() {
    // если есть номер телефона, то сразу его подставить
    this.form.phone = this.phone;

    this.$refs.loginphone.focus();
  },
};
</script>
